import React, { Component } from 'react';

export default class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {

		};
	}

	login = () => {
		console.log(window.location.origin)
		fetch(window.location.origin + window.location.pathname + 'login', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
			if (response.status == 200) {
				var response = await response.json()
				this.props.login(response)
			} else {
				this.setState({ loginError: await response.text() })
			}
		})
	}


	render() {
		return (
			<div style={{ textAlign: 'center', overflowWrap: 'break-word' }}>
				<h3 style={{ textAlign: 'center' }}>Welcome to the <br />Enteral Authorization portal. </h3>
				<hr />
				<p>Email Address</p>
				<input type="text" value={this.props.data.Email} onChange={(e) => { this.props.setData('Email', e.currentTarget.value) }} />

				<p>Password</p>
				<input type="password" value={this.props.data.Password} onChange={(e) => { this.props.setData('Password', e.currentTarget.value) }} />
				{this.state.loginError ? <div className="error">{this.state.loginError}</div> : ''}
				<div className="button" onClick={this.login}>Login</div>
				<div className="button" style={{ backgroundColor: '#888' }} onClick={this.props.register}>Register</div>
				<div className="button" style={{ backgroundColor: '#888' }} onClick={() => { this.props.reset() }}>Reset Password</div>
			</div>
		);

	}
}